export default class MeetingDomainService {
    static fromJSON(json) {
        return Object.assign(Object.assign({}, json), { startTime: json.startTime && new Date(json.startTime), endTime: json.endTime && new Date(json.endTime), 
            // THIS IS A HARDCODED VALUE TO NOT BREAK FRONTEND, REMOVE THIS WHEN BACKEND IS IMPLEMENTED
            meetingStatus: json.meetingStatus });
    }
    static getTitle(selfServiceCheckIn, meetingWithPersonName, meetingTypeName) {
        if (selfServiceCheckIn) {
            return "Self-Service Check-In";
        }
        const typeName = meetingTypeName || "Meeting";
        return meetingWithPersonName
            ? `${typeName} with ${meetingWithPersonName}`
            : typeName;
    }
    static getTitleForMeeting(meeting) {
        return MeetingDomainService.getTitle(meeting.selfServiceCheckIn, meeting.staff && meeting.staff.fullName, meeting.meetingTypeName);
    }
}
